import React, { useMemo, useState } from "react";
import styles from "./SummaryPanel.module.scss";
import { connect } from "react-redux";
import useGetTodayDate from "../../../hooks/useGetTodayDate";
import { Send, X, CalendarDays, User } from "lucide-react";

const SummaryPanel = ({
  totals,
  userData,
  setEndDate,
  endDate,
  handleSendQuotation,
  closeModal,
  note,
  setNote
}) => {
  const [isIvaChecked, setIsIvaChecked] = useState(false);

  const todayDate = useGetTodayDate();
  const formatter = useMemo(
    () =>
      new Intl.NumberFormat("es-AR", {
        style: "currency",
        currency: "ARS"
      }),
    []
  );

  const subtotal = totals.subtotal || 0;
  const ivaAmount = isIvaChecked ? subtotal * 0.21 : 0;
  const total = subtotal + ivaAmount;

  const handleDateChange = (event) => {
    const selectedDate = event.target.value;
    setEndDate(selectedDate);
  };

  const convertToISO = useMemo(() => {
    const [dd, mm, yyyy] = todayDate.split("/");
    return `${yyyy}-${mm}-${dd}`;
  }, [todayDate]);

  const requesterName =
    userData?.type === "COMPANY"
      ? userData?.razon_social
      : `${userData?.name ?? ""} ${userData?.last_name ?? ""}`.trim();

  return (
      <div className={styles.modal}>
        <header className={styles.header}>
          <div className={styles.headerTitle}>
            <span className={styles.headerEyebrow}>Resumen de envío</span>
            <h2>Confirma tu cotización</h2>
          </div>
          <button type="button" className={styles.closeButton} onClick={closeModal} aria-label="Cerrar resumen">
            <X size={18} />
          </button>
        </header>

        <section className={styles.requester}>
          <div className={styles.requesterIcon}>
            {userData?.image_profile ? (
              <img src={userData.image_profile} alt={requesterName || "Solicitante"} />
            ) : (
              <User size={18} />
            )}
          </div>
          <div className={styles.requesterInfo}>
            <span className={styles.requesterLabel}>Cotizando como</span>
            <span className={styles.requesterName}>{requesterName || "Usuario sin datos"}</span>
            {userData?.username && <span className={styles.requesterContact}>{userData.username}</span>}
          </div>
        </section>

        <section className={styles.details}>
          <div className={styles.detailsRow}>
            <div className={styles.detailLabel}>
              <CalendarDays size={16} />
              <span>Validez de la oferta</span>
            </div>
            <input
              type="date"
              value={endDate}
              onChange={handleDateChange}
              className={styles.dateInput}
              min={convertToISO}
            />
          </div>

          <div className={styles.detailsRow}>
            <label className={styles.toggle}>
              <input
                type="checkbox"
                checked={isIvaChecked}
                onChange={(event) => setIsIvaChecked(event.target.checked)}
              />
              <span>Incluir IVA (21%)</span>
            </label>
          </div>

          <div className={styles.summaryGrid}>
            <div className={styles.summaryItem}>
              <span className={styles.summaryLabel}>Subtotal</span>
              <span className={styles.summaryValue}>{formatter.format(subtotal)}</span>
            </div>
            <div className={styles.summaryItem}>
              <span className={styles.summaryLabel}>IVA 21%</span>
              <span className={styles.summaryValue}>{formatter.format(ivaAmount)}</span>
            </div>
            <div className={styles.summaryItemTotal}>
              <span>Total a enviar</span>
              <span>{formatter.format(total)}</span>
            </div>
          </div>

          <div className={styles.note}>
            <label className={styles.noteLabel}>Condiciones especiales</label>
            <textarea
              value={note}
              onChange={(event) => setNote(event.target.value)}
              placeholder="Ej: Tiempo de entrega estimado, garantías, medios de pago..."
            />
          </div>
        </section>

        <footer className={styles.footer}>
          <small>* Recuerda adjuntar toda la información necesaria antes de enviar tu cotización.</small>
          <button type="button" className={styles.submitButton} onClick={handleSendQuotation} disabled={!endDate}>
           <span className={styles.submitButtonIcon}>
            <Send size={18} />
           </span>
            Enviar
          </button>
        </footer>
      </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.general.userData
});

export default connect(mapStateToProps)(SummaryPanel);
